import { useTranslation } from 'react-i18next';

export function AntraegeTrigger() {
  const { t } = useTranslation();
  return <div>{t('domain.arbeitszeiten.sheet.tabs.anträge')}</div>;
}
